import React from "react";
import ReactDOM from "react-dom/client";
import App from "./routes/App";
import reportWebVitals from "./reportWebVitals";
import "./i18n";
import "moment-timezone";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import ShowGame from "./routes/ShowGame";
import PageNotFound from "./routes/PageNotFound";
import Games from "./routes/Games";
import Login from "./routes/Login";
import Logout from "./routes/Logout";
import { GlobalContextProvider } from "./store";
import Home from "./routes/Home";
import AddNewGame from "./routes/Administration/Game/Add";
import EditGame from "./routes/Administration/Game/Edit";

const root = ReactDOM.createRoot(document.getElementById("retro-games") as HTMLElement);

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        errorElement: <PageNotFound />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "/games",
                element: <Games />,
            },
            {
                path: "/games/:platform",
                element: <Games />,
            },
            {
                path: "/games/:orderBy/:orderCharacter",
                element: <Games />,
            },
            {
                path: "/games/:platform/:orderBy/:orderCharacter",
                element: <Games />,
            },
            {
                path: "/login",
                element: <Login />,
            },
            {
                path: "/logout",
                element: <Logout />,
            },
            {
                path: "/show-game/:gameUrl",
                element: <ShowGame />,
            },
            {
                path: "/administration/game/add",
                element: <AddNewGame />,
            },
            {
                path: "/administration/game/edit/:gameUrl",
                element: <EditGame />,
            },
        ],
    },
]);

/**
 * Always use React Router Link or NavLink components for your links in your
 * components, or you will loose your Context data (because of page refresh)!!!
 */
root.render(
    <React.StrictMode>
        <GlobalContextProvider>
            <RouterProvider router={router} />
        </GlobalContextProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
